<template>
  <el-dialog :title="$t('newContract')" :visible="isShowDialog" @close="closePopup()" width="600px">
    <span id="modal-body">
      <el-form ref="form" label-width="150px" style="width: 500px">
        <el-form-item :label="$t('hotel')" :required="true">
            <el-select v-model="hotelId" :placeholder="$t('hotel')">
              <el-option
                v-for="(hotel, index) in sortedHotelList"
                :key="index"
                :label="hotel.name"
                :value="hotel.id">
              </el-option>
            </el-select>
        </el-form-item>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onCreateButtonClick" :disabled="hotelId === ''">{{ $t('create') }}</el-button>
      <el-button type="default" @click="closePopup">{{ $t('cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import i18nMessages from '@/translations/Contract/components/PopupAddContract.i18n'

export default {
  name: 'PopupAddContract',
  i18n: { messages: i18nMessages },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    hotelList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  created: function () {
    this.sortedHotelList = this.hotelList.sort((a, b) => {
      return (a.name > b.name) ? 1 : -1
    })
  },
  data () {
    return {
      isShowDialog: false,
      hotelId: '',
      sortedHotelList: []
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
    }
  },
  methods: {
    onCreateButtonClick: async function () {
      this.$emit('onSelectedHotel', this.hotelId)

      this.closePopup()
      this.clear()
    },
    closePopup: function () {
      this.isShowDialog = false
      this.$emit('onClose')
    },
    clear: function () {
      this.hotelId = ''
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
